// extracted by mini-css-extract-plugin
export var statItem = "_kx-1";
export var statsRow = "_kx-0";